<template>
  <div class="register_container">
    <div class="top-layout">
      <div class="left"><img src="@/assets/register/Frame 219.png" /><div>Listek IOT Platform</div></div>
      <div class="language">
      <el-popover placement="bottom" trigger="click" ref="popover">
        <div class="language-text-layout">
          <div class="language-text" @click="changeLanguage('zh')">{{ $t('account.name10') }}</div>
          <div class="language-text" @click="changeLanguage('en')">English</div>
        </div>
        <div slot="reference">{{ language }}<i class="el-icon-arrow-down"></i></div>
      </el-popover>
    </div>
    </div>
    <img class="img" src="@/assets/register/Mask group.png" />

    <div class="login_box">
      <div class="fhzsb" @click="goLogin">
        <img src="@/assets/register/Frame.png" />
        <div class="text">{{$t('register.name1')}}</div>
      </div>
      <div class="login">
        <div class="login_name">
          <div>{{$t('register.name2')}}</div>
        </div>
        <el-form ref="registerFormRef" :model="registerForm" :rules="registerFormRules" :label-width="formLabelWidth('none')" class="login_form">
          <el-form-item prop="manufacturer">
            <el-select v-model="registerForm.manufacturer" :placeholder="$t('public.name1')" style="width:100%">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="companyName">
            <el-input v-model="registerForm.companyName" :placeholder="$t('register.name3')"></el-input>
          </el-form-item>

          <el-form-item prop="email">
            <el-input v-model="registerForm.email" :placeholder="$t('register.name4')" :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
          </el-form-item>

          <div class="code-layout">
            <el-form-item prop="code">
              <el-input v-model="registerForm.code" type="text" :placeholder="$t('register.name5')" class="code-input" :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
            </el-form-item>
            <div class="code" @click="getCode">{{$t('register.name6')}}</div>
          </div>

          <el-form-item prop="password">
            <el-input v-model="registerForm.password" :placeholder="$t('register.name7')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
          </el-form-item>

          <el-form-item prop="confirmPassWord">
            <el-input v-model="registerForm.confirmPassWord" :placeholder="$t('register.name8')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"> </el-input>
          </el-form-item>
        </el-form>
        <div class="checked-forget">
          <div>
            <el-checkbox v-model="checked"><span>{{$t('register.name9')}}</span><span class="ystk">{{$t('register.name10')}}</span></el-checkbox>
          </div>
        </div>

        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="register">{{$t('register.name11')}}</el-button>

        <div class="btns text-style" @click="goLogin">{{$t('register.name12')}}</div>
      </div>
    </div>
    <div class="copyright">{{$t('register.name13')}}</div>
  </div>
</template>
<script>
import { validateEmail, validatePass } from '@/utils/utils.js'
export default {
  data() {
    var validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('retrievePassword.name14')))
      } else if (value !== this.passWordForm.loginPwd) {
        callback(new Error(this.$t('retrievePassword.name15')))
      } else {
        callback()
      }
    }
    return {
      // 这是登录表单的数据对象
      registerForm: {
        manufacturer: '1',
        companyName: '',
        email: '',
        code: '',
        password: '',
        confirmPassWord: ''
      },
      // 这是表单验证规则对象
      registerFormRules: {
        // 验证用户名是否合法
        companyName: [
          {
            required: true,
            message: this.$t('register.name3'),
            trigger: 'blur'
          }
        ],

        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        code: [
          {
            required: true,
            message: this.$t('login.name4'),
            trigger: 'blur'
          }
          // {
          //   min: 6,
          //   max: 15,
          //   message: '长度在 6 到 15 个字符',
          //   trigger: 'blur'
          // }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        confirmPassWord: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ]
      },
      isShowYS: false,
      loading: false,
      checked: false,
      options: [
        {
          value: '1',
          label: '我是OEM厂商'
        },
        {
          value: '2',
          label: '我是租赁厂商'
        }
      ],
      language: this.$t('account.name10'),
      readonlyInput: true
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  created() {
    if (localStorage.getItem('lang') === 'en') {
      this.language = 'English'
    } else {
      this.language = this.$t('account.name10')
    }
  },
  methods: {
    cancelReadOnly() {
      this.readonlyInput = false
    },
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    showYS() {
      this.isShowYS = !this.isShowYS
    },
    getCode() {},
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.$bus.$emit('lang', lang)
      if (lang === 'zh') {
        this.language = this.$t('account.name10')
      } else {
        this.language = 'English'
      }
      this.$refs.popover.doClose()
    },
    goLogin() {
      this.$router.push('/login')
    },
    register() {
      this.$refs.registerFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/login', this.registerForm)
            .then(() => {
              this.$router.push('/login')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss">

.el-popover {
  min-width: 70px;
}
.custom-icon {
  width: 16px;
  height: 16px;
  line-height: 16px;
  margin-left: 5px;
  background-image: url(~@/assets/login/Frame.png);
  background-size: cover;
  display: inline-block;
}
.el-select .el-input {
  width: 100%;
}
</style>

<style lang="scss" scoped>
.register_container {
  background: #ffffff;
  background-size: cover;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background-image: url(~@/assets/login/Maskgroup.jpg);
  // background-size: 100% 100%;
  .img {
    width: 100%;
    height: 24.65vw;
    min-width: 1440px;
    min-height: 355px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

.language-text-layout {
  display: flex;
  flex-direction: column;
  .language-text {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
  }

  .language-text:hover {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: #0f73e6;
  }
}
.code-layout {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
}
.text-style {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: #0f73e6;
  cursor: pointer;
}

.btns {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.margin-top20 {
  margin-top: 20px;
}

.checked-forget {
  margin-top: -10px;
  width: 100%;
  display: flex;
  align-items: center;
}
.zsb-tyb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;

}
.ystk {
  color: #0f73e6;
}

.icon-zsb {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 16px;
    hheight: 16px;
  }
  span {
    margin-left: 4px;
    font-size: 16px;
    line-height: 22.4px;
  }
}
.el-icon-refresh {
  margin-bottom: 22px;
  margin-left: 8px;
}
.code-input {
  width: 184px;
}
.code {
  background: #064d9d;
  width: 104px;
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
  font-size: 16px;
  margin-left: 12px;
  margin-bottom: 22px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}

.fhzsb {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
    cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  .text {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    color: #b9babb;
    margin-left: 4px;
  }
}

.login_box {
  box-shadow: 0px 4px 10px 0px #00000029;
  width: 400px;
  height: 604px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login_box .login_l_img {
  float: left;
  width: 432px;
  height: 440px;
  margin-left: 50px;
}

.login_box .login_l_img img {
  width: 500px;
  height: 440px;
}

.top-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  height: 70px;
  width: 100%;
  background: #0f73e6;
  top: 0px;
  .left{
    display: flex;
    flex-direction: row;
    img {
    width: 36px;
    height: 36px;
    margin-left: 30px;
  }
  div {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    text-align: left;
    margin-left: 12px;
    color: #ffffff;
  }
  }
  .language {
  position: absolute;
  right: 60px;
  top: 30px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  .el-icon-arrow-down {
    font-size: 18px;
    margin-left: 5px;
    color: #ffffff;
  }
}
}

.login {
  height: 100%;
  width: 100%;
  padding-top: 0px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: #ffffff;
  border-radius: 0px;
  box-sizing: border-box;
  position: relative;
}

.login_logo {
  width: 120px;
  height: 120px;
  border: 5px solid #93defe;
  border-radius: 100px;
  background: #fff;
  text-align: center;
  line-height: 110px;
  position: absolute;
  top: -60px;
  right: 140px;
}

.login_name {
  width: 100%;
  text-align: center;
}

.login_name div {
  width: 100%;
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  line-height: 33.6px;
  font-weight: 500;
  color: #555555;
  font-family: PingFang SC;
}

.login_logo img {
  width: 100px;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
}

.copyright {
  font-size: 14px;
  color: #515357;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 30px;
}
</style>
